module.exports = __webpack_public_path__ + "img/zd-top-5.583e201d.svg";